import clsx from 'clsx';
import React, { Fragment, useState, useRef } from 'react';
import validator from 'validator';
import { connect } from 'react-redux';
import scrollIntoView from 'scroll-into-view';
import { preventDefault, getFileMetaData } from '../../../../containers/Admin/helper';
import history from '../../../../routes/history';
import { withStyles } from '@material-ui/core/styles';
import SnakBar from '../../../SnakBar';
import PageHeader from '../../../common/PageHeader';
import Icons from '../../../../containers/Permitting/Chats/images';
import uploadFileDetails from '../../../../utils/uploadFileDetails';
import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  makeStyles,
  IconButton,
  Switch,
  Divider,
  Chip,
} from '@material-ui/core';
import DeleteIcon from '../../../../containers/Permitting/TemplateDialog/DeleteTemplateIcon';
import CloseIcon from '@material-ui/icons/Close';
import { isEmpty, get, keysIn, hasIn, omit, isEqual, includes, inRange } from '../../../../utils/lodash';
import CustomPanel from '../../../common/PanelTemplate';
import { getSGMaterials } from '../../../../containers/Permitting/action';
import { Label } from '../../../common/Label';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { theme } from 'highcharts';
import SolarAndBatteryImage from './SolarAndBatteryImage';
import BatteryOnlyImage from './BatteryOnlyImage';
import GridTiedBatteryImage from './GridTiedBatteryImage';

const useStyles = makeStyles((theme) => ({
  root: {
    ...theme.mixins.gutters(),
    backgroundColor: theme.palette.background.paper,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  actionButtons: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  backdrop: {
    zIndex: 11,
    color: theme.palette.primary.main,
  },
  btnStyle: { marginLeft: theme.spacing(0.5), color: 'white' },
  subRoot: {
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(1),
  },
  contactDetails: {
    padding: theme.spacing(0, 3, 2, 3),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(0, 1, 4, 1),
    },
  },
  inputWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap',
    },
  },
  addressWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '45%',
    height: '100%',
    position: 'relative',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  inputField: {
    minWidth: theme.spacing(30),
    margin: theme.spacing(2, 0, 1, 0),
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      // marginTop: theme.spacing(1),
      marginLeft: 0,
    },
    '& .Mui-focused': {
      '& label': {
        color: theme.palette.primary.main,
      },
    },
    '& .MuiInputLabel-shrink': {
      '& label': {
        fontWeight: 400,
        color: theme.palette.primary.lightBlack,
      },
    },
    '& .MuiSelect-select': { whiteSpace: 'normal' },
    '& .MuiInputBase-root.Mui-disabled:before': {
      borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
    },
    '& .MuiInputBase-root.Mui-disabled': {
      color: 'rgba(0, 0, 0, 0.87)',
    },
  },
  addBatteryConfigurationButton: {
    width: '152px',
    // marginRight: theme.spacing(3),
    marginTop: theme.spacing(2),
    marginLeft: 'auto',
    height: '40px',
    border: '1px solid #F37320',
    borderRadius: '2px',
    opacity: 1,
    color: '#F37320',
    // marginBottom: '6px',
    textTransform: 'none',
    background: '#FFFFFF',
    fontWeight: 600,
    '&:hover': { background: '#FFFFFF' },
    minWidth: 'max-content',
    maxWidth: 'max-content',
    '&.Mui-disabled': {
      background: '#eaeaea',
      color: '#FFFFFF',
      border: '1px solid #FFFFFF',
    },
  },
  uploadDataField: {
    width: '44%',
    margin: theme.spacing(5, 1, 0),
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  uploadDataLabel: {
    margin: theme.spacing(1, 0),
  },
  filesListWrapper: {
    border: `1px solid #bbb`,
    borderRadius: theme.spacing(0.5),
    maxHeight: theme.spacing(10),
    // marginRight: theme.spacing(10),
  },
  fileAttachment: {
    display: 'flex',
    alignItems: 'left',
    justifyContent: 'space-between',
    padding: theme.spacing(0.75),
  },
  fileNameIconWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  listItemAttachmentIcon: {
    pointerEvents: 'auto',
  },
  iconCoverChat: {
    height: theme.spacing(5),
    width: theme.spacing(5),
    padding: theme.spacing(1),
    '& .MuiIconButton-label': {
      height: '100%',
      '& svg': {
        height: '100%',
      },
    },
  },
  popupCloseBtn: {
    color: '#335977',
    align: 'right',
    float: 'right',
    minWidth: theme.spacing(2.5),
  },
  errorText: {
    fontSize: theme.spacing(1.75),
    color: '#f44336',
    marginLeft: theme.spacing(0),
    marginTop: theme.spacing(0.3),
  },
  hidden: {
    display: 'none',
  },
  container: {
    justifyContent: 'space-between',
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingBottom: theme.spacing(1),
  },
  tagsRow: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },

  tagWrapper: {
    marginBottom: 14,
    marginTop: 28,
    position: 'relative',
  },
  // active (focused) floating label — orange, using form background so it matches other labels
  tagLabelFloating: {
    position: 'absolute',
    top: -12,
    left: 1,
    fontSize: 11,
    color: '#f07f3a',
    backgroundColor: theme.palette.background.paper,
    padding: '0 6px',
    display: 'inline-block',
    fontWeight: 500,
    zIndex: 3,
    userSelect: 'none',
  },
  tagLabelPlaceholder: {
    position: 'absolute',
    top: '30%',
    left: 10,
    transform: 'translateY(-50%)',
    fontSize: 13,
    color: '#999',
    pointerEvents: 'none',
    transition: 'all 0.2s',
  },
  // floating but not focused — grey (matches other labels)
  tagLabelFloatingNotFocused: {
    position: 'absolute',
    top: -12,
    left: 1,
    fontSize: 11,
    color: theme.palette.primary.lightBlack,
    backgroundColor: theme.palette.background.paper,
    padding: '0 6px',
    display: 'inline-block',
    fontWeight: 500,
    zIndex: 3,
    userSelect: 'none',
  },
  tagContainer: {
    border: '1px solid #c4c4c4',
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 1,
    minHeight: 45,
    padding: '3px 4px',
    position: 'relative',
    cursor: 'text',
    transition: 'border-color 0.2s',
    marginTop: 8,
  },
  tagContainerFocused: {
    borderColor: '#f07f3a',
    borderWidth: '2px',
  },
  tagChip: {
    display: 'inline-flex',
    alignItems: 'center',
    marginRight: 6,
    marginBottom: 6,
    background: '#f07f3a',
    color: '#fff',
    padding: '4px 6px',
    borderRadius: 12,
    fontSize: 12,
  },
  tagChipRemoveBtn: {
    marginLeft: 6,
    cursor: 'pointer',
    fontWeight: 700,
    border: 'none',
    background: 'transparent',
    color: '#fff',
    fontSize: 14,
    lineHeight: 1,
  },
  tagInput: {
    border: 'none',
    outline: 'none',
    fontSize: 13,
    minWidth: 96,
    padding: '4px 3px',
    background: 'transparent',
    flex: 1,
  },
}));

const TagInput = ({ label, stateKey, value = [], onUpdate, readOnly, classes }) => {
  const [focused, setFocused] = useState(false);
  const inputRef = useRef(null);
  const list = Array.isArray(value) ? value : [];

  const normalize = (s) => String(s ?? '').trim();
  const exists = (arr, v) => arr.some((t) => normalize(t).toLowerCase() === normalize(v).toLowerCase());

  const normalizeIncomingTags = (arr) => {
    if (!Array.isArray(arr)) return [];
    return Array.from(new Set(arr.map((v) => String(v ?? '').trim()).filter(Boolean)));
  };

  const addValues = (vals, keepFocus = true) => {
    const cleaned = vals.map(normalize).filter(Boolean);
    if (!cleaned.length) return;

    const toAdd = cleaned.filter((v) => !exists(list, v));
    if (!toAdd.length) {
      if (inputRef.current) inputRef.current.value = '';
      return;
    }

    const newList = [...list, ...toAdd];

    onUpdate({ target: { value: newList } }, stateKey);

    if (inputRef.current) {
      inputRef.current.value = '';
      if (keepFocus) inputRef.current.focus();
    }
  };

  const removeAt = (idx) => {
    const next = [...list];
    next.splice(idx, 1);
    onUpdate({ target: { value: next } }, stateKey);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      const value = e.target.value || '';
      const parts = value
        .split(/[,;\n]+/)
        .map((s) => s.trim())
        .filter(Boolean);
      addValues(parts, true);
    }

    if (e.key === 'Backspace' && (!e.target.value || e.target.value.trim() === '') && list.length) {
      removeAt(list.length - 1);
    }
  };

  const handleBlur = (e) => {
    setFocused(false);
    const value = e.target.value || '';
    const parts = value
      .split(/[,;\n]+/)
      .map((s) => s.trim())
      .filter(Boolean);
    addValues(parts, false);
  };

  const handlePaste = (e) => {
    const text = (e.clipboardData || window.clipboardData).getData('text');
    if (!text) return;
    e.preventDefault();
    const parts = text
      .split(/[,;\n]+/)
      .map((s) => s.trim())
      .filter(Boolean);
    addValues(parts, true);
  };

  const labelClass = focused
    ? classes.tagLabelFloating
    : list.length > 0
    ? classes.tagLabelFloatingNotFocused
    : classes.tagLabelPlaceholder;

  return (
    <Box className={classes.tagWrapper}>
      <span className={labelClass}>{label}</span>

      <Box
        className={clsx(classes.tagContainer, focused && classes.tagContainerFocused)}
        onClick={() => inputRef.current && inputRef.current.focus()}
        role="list"
        aria-label={label}
      >
        {list.map((t, i) => (
          <Chip
            key={`${stateKey}-${i}-${t}`}
            label={t}
            onDelete={!readOnly ? () => removeAt(i) : undefined}
            deleteIcon={<CloseIcon />}
            size="small"
            className={classes.tagChip}
            classes={{ deleteIcon: classes.tagChipRemoveBtn }}
          />
        ))}

        {!readOnly && (
          <input
            ref={inputRef}
            type="text"
            onKeyDown={handleKeyDown}
            onBlur={handleBlur}
            onFocus={() => setFocused(true)}
            onPaste={handlePaste}
            className={classes.tagInput}
            aria-label={label}
            placeholder=""
          />
        )}
      </Box>
    </Box>
  );
};

const BatteryConfiguration = (props) => {
  const classes = useStyles();
  const {
    manufacturer,
    battery_group,
    configuration_name,
    batteryBackupAndQuantityList,
    manufacturersList,
    batteryGroupsList,
    handleDetails,
    batteryBackupsList,
    handleAddBatteryButtonClick,
    handleRemoveBattery,
    isBatteryOnlyImageToggleSet,
    handleBatteryOnlyImageToggle,
    isGridTiedBatteryImageToggleSet,
    handleGridTiedBatteryImageToggle,
    indoorImages,
    outdoorImages,
    withoutBackgroundImages,
    fileIcon,
    fileUploadLogs,
    deleteFile,
    errorData,
    handleFilesUpload,
    handleFileDownload,
    edit,
    tags_enfin = [],
    tags_goodleap = [],
    tags_lightreach = [],
  } = props;

  return (
    <Box className={classes.subRoot} key={`battery_configuration`}>
      <CustomPanel header={`Battery Configuration`}>
        <Grid className={classes.contactDetails}>
          <Grid className={classes.inputWrapper}>
            <Box className={classes.addressWrapper}>
              <Autocomplete
                id="manufacturer"
                className={classes.inputField}
                inputValue={manufacturer}
                disabled={edit}
                options={manufacturersList}
                getOptionLabel={(option) => (typeof option === 'string' ? option : option['name'])}
                disableClearable
                onInputChange={(e, value) => handleDetails(e, 'manufacturer', value)}
                renderInput={(params) => <TextField {...params} label={<Label text={'Manufacturer'} />} />}
              />
            </Box>
            <Box className={classes.addressWrapper}>
              <Autocomplete
                id="battery_group"
                className={classes.inputField}
                inputValue={battery_group}
                options={batteryGroupsList}
                getOptionLabel={(option) => (typeof option === 'string' ? option : option['name'])}
                disableClearable
                disabled={isEmpty(manufacturer) || edit}
                onInputChange={(e, value) => handleDetails(e, 'battery_group', value)}
                renderInput={(params) => <TextField {...params} label={<Label text={'Battery Group'} />} />}
              />
            </Box>
          </Grid>
          <Grid className={classes.inputWrapper}>
            <Box className={classes.addressWrapper}>
              <TextField
                id={'configuration_name'}
                className={classes.inputField}
                label={<Label text={'Configuration Name'} />}
                value={configuration_name || ''}
                onChange={(e, value) => handleDetails(e, 'configuration_name', value)}
              />
            </Box>

            {/* Right side of Configuration Name: Enfin tags */}
            <Box className={classes.addressWrapper}>
              <TagInput
                label={'Battery configuration tags (Enfin)'}
                stateKey={'tags_enfin'}
                value={tags_enfin}
                onUpdate={handleDetails}
                classes={classes}
              />
            </Box>
          </Grid>
          <Grid className={classes.inputWrapper}>
            <Box className={classes.addressWrapper}>
              <TagInput
                label={'Battery configuration tags (Goodleap)'}
                stateKey={'tags_goodleap'}
                value={tags_goodleap}
                onUpdate={handleDetails}
                classes={classes}
              />
            </Box>
            <Box className={classes.addressWrapper}>
              <TagInput
                label={'Battery configuration tags (Lightreach)'}
                stateKey={'tags_lightreach'}
                value={tags_lightreach}
                onUpdate={handleDetails}
                classes={classes}
              />
            </Box>
          </Grid>

          <Box className={classes.subRoot}>
            <CustomPanel header={`Battery`}>
              <Grid className={classes.contactDetails}>
                {batteryBackupAndQuantityList.map((batteryBackupAndQuantity) => {
                  return (
                    <Grid className={classes.inputWrapper}>
                      <Box className={classes.addressWrapper} style={{ marginRight: '10%' }}>
                        <Autocomplete
                          id={`battery_backup_${batteryBackupAndQuantity.id}`}
                          // key={`battery_backup_${batteryBackupAndQuantity.id}`}
                          className={classes.inputField}
                          inputValue={batteryBackupAndQuantity['battery_backup']}
                          options={batteryBackupsList}
                          getOptionLabel={(option) => (typeof option === 'string' ? option : option['name'])}
                          disableClearable
                          disabled={isEmpty(battery_group)}
                          onInputChange={(e, value) =>
                            handleDetails(e, 'battery_backup', value, batteryBackupAndQuantity.id)
                          }
                          renderInput={(params) => <TextField {...params} label={<Label text={'Batteries'} />} />}
                        />
                      </Box>
                      <TextField
                        style={{ flexGrow: 1 }}
                        id={`quantity_${batteryBackupAndQuantity.id}`}
                        // key={`quantity_${batteryBackupAndQuantity.id}`}
                        className={classes.inputField}
                        label={<Label text={'Quantity'} />}
                        value={batteryBackupAndQuantity['quantity'] || ''}
                        disabled={isEmpty(battery_group)}
                        error={!isEmpty(get(errorData.quantities, batteryBackupAndQuantity.id))}
                        helperText={get(errorData.quantities, batteryBackupAndQuantity.id)}
                        onChange={(e, value) => handleDetails(e, 'quantity', value, batteryBackupAndQuantity.id)}
                      />
                      {batteryBackupAndQuantity.id > 1 && (
                        <IconButton size="small" onClick={() => handleRemoveBattery(batteryBackupAndQuantity.id)}>
                          <DeleteIcon />
                        </IconButton>
                      )}
                    </Grid>
                  );
                })}
                <Button
                  disableRipple
                  disableElevation
                  className={clsx(classes.addBatteryConfigurationButton)}
                  onClick={handleAddBatteryButtonClick}
                >
                  {' '}
                  + ADD BATTERY{' '}
                </Button>
              </Grid>
            </CustomPanel>
          </Box>
          <Typography className={classes.inputField} style={{ fontWeight: '500', marginBottom: '16px' }}>
            Battery Images
          </Typography>
          <SolarAndBatteryImage
            indoorImages={indoorImages}
            outdoorImages={outdoorImages}
            withoutBackgroundImages={withoutBackgroundImages}
            fileIcon={fileIcon}
            fileUploadLogs={fileUploadLogs}
            deleteFile={deleteFile}
            errorData={errorData}
            handleFilesUpload={handleFilesUpload}
            handleFileDownload={handleFileDownload}
          />
          <BatteryOnlyImage
            indoorImages={indoorImages}
            outdoorImages={outdoorImages}
            withoutBackgroundImages={withoutBackgroundImages}
            fileIcon={fileIcon}
            fileUploadLogs={fileUploadLogs}
            deleteFile={deleteFile}
            errorData={errorData}
            handleFilesUpload={handleFilesUpload}
            isBatteryOnlyImageToggleSet={isBatteryOnlyImageToggleSet}
            handleBatteryOnlyImageToggle={handleBatteryOnlyImageToggle}
            handleFileDownload={handleFileDownload}
          />
          <GridTiedBatteryImage
            handleBatteryOnlyImageToggle={handleBatteryOnlyImageToggle}
            indoorImages={indoorImages}
            outdoorImages={outdoorImages}
            withoutBackgroundImages={withoutBackgroundImages}
            fileIcon={fileIcon}
            fileUploadLogs={fileUploadLogs}
            deleteFile={deleteFile}
            errorData={errorData}
            handleFilesUpload={handleFilesUpload}
            isGridTiedBatteryImageToggleSet={isGridTiedBatteryImageToggleSet}
            handleGridTiedBatteryImageToggle={handleGridTiedBatteryImageToggle}
            handleFileDownload={handleFileDownload}
          />
        </Grid>
      </CustomPanel>
    </Box>
  );
};

export default BatteryConfiguration;
